import { t } from "i18next";
import { Fragment } from "react";
import { ComputeFieldComponent } from "../computeFields";

export type TirageHistoryItem = {
  tirageHistoriqueHistoriqueNom: string;
  tirageHistoriqueHistoriqueVille?: string | null;
  tirageHistoriqueHistoriqueCollectionParticuliere: boolean;
};

export const TirageHistoryCF: ComputeFieldComponent<{
  tirageHistory: TirageHistoryItem[];
}> = ({ input, language, translation, lineBreak = true }) => {
  if (!input.tirageHistory || input.tirageHistory.length === 0) {
    return null;
  }

  const historyItems = input.tirageHistory.map((history, index) => {
    const location = history.tirageHistoriqueHistoriqueCollectionParticuliere
      ? (translation
          ? translation("computeField.collectionParticuliere")
          : t("computeField.collectionParticuliere", { lng: language }))
      : history.tirageHistoriqueHistoriqueNom || "";
    const city = history.tirageHistoriqueHistoriqueVille?.trim();
    const parts = [location, city].filter(Boolean);
    const content = parts.join(", ");

    return (
      <Fragment key={index}>
        {content}
        {index < input.tirageHistory.length - 1 && lineBreak && <br />}
      </Fragment>
    );
  });

  return <>{historyItems}</>;
};

